export const VED_COMMON = 'vedCommon';

export const VED_COMMON_ACTIONS_NAME = {
  searchCountriesTree: `${VED_COMMON}/searchCountriesTree`,
  searchRegionsRfTree: `${VED_COMMON}/searchRegionsRfTree`,
  searchCustomsOrgansOnBorder: `${VED_COMMON}/searchCustomsOrgansOnBorder`,
  searchCustomsOrgansOnBorderTree: `${VED_COMMON}/searchCustomsOrgansOnBorderTree`,
} as const;

export const VED_COMMON_MUTATIONS_NAME = {
  setCountriesTree: `${VED_COMMON}/setCountriesTree`,
  setRegionsRfTree: `${VED_COMMON}/setRegionsRfTree`,
  setCustomsOrgansOnBorder: `${VED_COMMON}/setCustomsOrgansOnBorder`,
  setCustomsOrgansOnBorderTree: `${VED_COMMON}/setCustomsOrgansOnBorderTree`,
} as const;

export const VED_COMMON_GETTERS_NAME = {
  getCountriesTree: `${VED_COMMON}/getCountriesTree`,
  getRegionsRfTree: `${VED_COMMON}/getRegionsRfTree`,
  getCustomsOrgansOnBorder: `${VED_COMMON}/getCustomsOrgansOnBorder`,
  getCustomsOrgansOnBorderTree: `${VED_COMMON}/getCustomsOrgansOnBorderTree`,
} as const;
